interface AuthErrorMessage {
  header: string;
  message: string;
}

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'Nieprawidłowy e-mail lub hasło.',
  'auth/user-disabled': 'Twoje konto zostało zablokowane. Skontaktuj się z pomocą techniczną.',
  'auth/too-many-requests': 'Zbyt wiele nieudanych prób. Spróbuj ponownie za chwilę.',
  'auth/network-request-failed': 'Sprawdź połączenie z internetem i spróbuj ponownie.',

  'auth/email-already-in-use': 'Ten adres e-mail jest już zajęty.',
  'auth/invalid-email': 'Podaj poprawny adres e-mail.',
  'auth/weak-password': 'Hasło jest za słabe. Musi mieć co najmniej 6 znaków.',

  'auth/account-exists-with-different-credential':
    'To konto jest powiązane z inną metodą logowania. Użyj pierwotnej metody.',

  'auth/user-not-found': 'Nie znaleziono konta z tym adresem e-mail.',

  'auth/wrong-password': 'Nieprawidłowy e-mail lub hasło.'
};

export const getFirebaseAuthErrorMessage = (error: unknown, defaultHeader: string = 'Błąd'): AuthErrorMessage => {
  const code: string = (error as { code?: string })?.code ?? '';
  return {
    header: defaultHeader,
    message: AUTH_ERROR_MESSAGES[code] ?? 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.'
  };
};
